import {
  CmpSelectBox,
  CmpButton,
  CmpDatePicker,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { CircularProgress } from "@mui/material";
import { fExecuteAPI } from "../../Server/Apis";
import { useSelector } from "react-redux";
import {
  InstantPickingList_Set,
  InstantPickingData_Set,
  InstantPickingHead_Set,
} from "./SliceInstantPickingHead";
import moment from "moment";
import {
  fAlertToast,
  GetGitterColumns,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import InstantPicking_Breadcrumbs from "./instantPicking_BreadCrumbs";
import useMediaQuery from "@mui/material/useMediaQuery";
import { CmpTextFieldEnter } from "./../../Component/Common/ToolBox/ToolBox";
import InstantPickingSummaryModal from "./component/InstantPickingSummaryModal";
import { InstantPickingSummaryCard } from "./component/InstantPickingSummaryCard";
const statusData = [
  {
    id: "N",
    statusName: "Pending",
  },
  {
    id: "Y",
    statusName: "Completed",
  },
  {
    id: "B",
    statusName: "All",
  },
];
const columns = [
  {
    field: "VocNo",
    headerName: "Doc.No",
    width: 150,
  },
  {
    field: "PostDate",
    headerName: "Date",
    width: 200,
    valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
  },
  {
    field: "PartyName",
    headerName: "Party Name",
    width: 300,
  },
  {
    field: "Status",
    headerName: "Status",
    width: 200,
  },
];
export default function InstantPickingHead() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const LocationFocusOnLoad = useRef(null);
  const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value);
  const vRdxInstantPickingData = useSelector(
    (state) => state.SliceInstantPickingHead.value.InstantPickingData
  );
  const vRdxInstantPickingList = useSelector(
    (state) => state.SliceInstantPickingHead.value.InstantPickingList
  );

  const [sLoading, setLoading] = useState(false);
  const [sInstPackingData, setInstPackingData] = useState(
    vRdxInstantPickingList
  );
  const [sinstanceData, setInstanceData] = useState(vRdxInstantPickingData);
  const [sLocation, SetLocation] = useState(vRdxuserLoc);
  const fInstantPicking = useCallback(
    (e) => {
      setInstanceData((obj) => ({
        ...obj,
        [e.target.name]: e.target.value,
      }));
    },
    [sinstanceData]
  );
  //  PostDate: moment(obj.PostDate).format("DD/MM/YYYY")
  const itemRows = sInstPackingData?.map((obj, i) => ({
    ...obj,
    id: i + 1,
    // PostDate: moment(obj.PostDate).format("DD/MM/YYYY"),
  }));
  // modal start

  const [showModal, setShowModal] = useState(false);

  // modal end

  const fLoad = (e) => {
    dispatch(
      InstantPickingData_Set({
        InstantPickingData: sinstanceData,
      })
    );
    GetInstancePickingData();
  };
  const GetInstancePickingData = async () => {
    setLoading(true);
    var vInstantPickingData = {
      v_Loc: sinstanceData.loc == "" ? vRdxuserLoc[0]?.UID : sinstanceData.loc,
      v_Date1: moment(sinstanceData.dateFrom).format("MM/DD/YYYY"),
      v_Date2: moment(sinstanceData.dateTo).format("MM/DD/YYYY"),
      v_Status:
        sinstanceData.statusVal == ""
          ? statusData[0].id
          : sinstanceData.statusVal,
      v_VocNo: sinstanceData?.docNo,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vInstantPickingData);
    const vItemSearch = await fExecuteAPI("INSTANCE_PICKING_GETROW", FinalObj);
    if (vItemSearch.Type?.toUpperCase() === "SUCCESS") {
      dispatch(
        InstantPickingList_Set({
          InstantPickingList: vItemSearch.ResultSet,
        })
      );
      
    } else {
      fAlertToast("FAILED", vItemSearch.Message);
    }
    setLoading(false);
    setShowModal(false);
  };

  const fInstantPickingHeadObj = (item) => {
    dispatch(
      InstantPickingHead_Set({
        InstantPickingHead: {
          VocTyp: item.row.VocTyp,
          VocTypName: item.row.VocTypName,
          VocNo: item.row.VocNo,
          PostDate: item.row.PostDate,
          Party: item.row.Party,
          PartyName: item.row.PartyName,
          Loc: item.row.Loc,
          LocName: item.row.LocName,
          DocStatus: item.row.DocStatus,
          InstancePicking: item.row.InstancePicking,
          BinCode: item.row.BinCode,
          BinName: item.row.BinName,
          Status: item.row.Status,
        },
      })
    );
    navigate("/InstantPickingDetail");
  };

  useEffect(() => {
    setInstPackingData(vRdxInstantPickingList);
  }, [vRdxInstantPickingList]);
  useEffect(() => {
    GetInstancePickingData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    SetLocation(vRdxuserLoc);
  }, [vRdxuserLoc]);

  const [sSummaryGridColumn2, setSummaryGridColumn2] = useState([]);

  useEffect(() => {
    GetGitterColumns(setSummaryGridColumn2, "INSTANTPICKING_SUMMARY", columns);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    LocationFocusOnLoad.current?.focus();
  }, []);
  return (
    <div className="container-fluid my-3">
      <div className="Breadcrumbs d-flex justify-content-center align-items-center">
        {/* eslint-disable-next-line react/jsx-pascal-case */}
        <InstantPicking_Breadcrumbs />
        <CmpButton
          xbtnName="Filter"
          xOnClick={() => {
            setShowModal(true);
          }}
          xVariant="contained"
          xSize="small"
        />
      </div>
      <div className="Instant-picking-head">
        {/* <Grid container spacing={2}>
          <Grid item lg={2} md={4} xs={6}>
            <CmpSelectBox
              xref={LocationFocusOnLoad}
              xLabelText="Location"
              xValue={
                sinstanceData.loc === ""
                  ? vRdxuserLoc[0]?.UID
                  : sinstanceData.loc
              }
              xOnChange={(event) => fInstantPicking(event)}
              xName={"loc"}
              xData={sLocation}
              xValueMember={""}
              xDispalyMember={""}
              xError={false}
              xErrorMessage={false}
              xDisable={false}
            />
          </Grid>
          <Grid item lg={2} md={4} xs={6} className="bintransfer-data-date">
            <CmpDatePicker
              xLabelText={"From"}
              xValue={sinstanceData.dateFrom}
              xOnChange={(newValue) => {
                setInstanceData((obj) => ({
                  ...obj,
                  dateFrom: newValue.$d,
                }));
              }}
              xName={"dateFrom"}
              xError={false}
              xErrorMessage={false}
            />
          </Grid>
          <Grid item lg={2} md={4} xs={6} className="bintransfer-data-date">
            <CmpDatePicker
              xLabelText={"To"}
              xValue={sinstanceData.dateTo}
              xOnChange={(newValue) =>
                setInstanceData((obj) => ({ ...obj, dateTo: newValue.$d }))
              }
              xName={"dateTo"}
              xError={false}
              xErrorMessage={false}
            />
          </Grid>
          <Grid item lg={2} md={4} xs={6}>
            <CmpSelectBox
              xLabelText="Status"
              xValue={
                sinstanceData.statusVal == ""
                  ? statusData[0].id
                  : sinstanceData.statusVal
              }
              xOnChange={(event) => fInstantPicking(event)}
              xName={"statusVal"}
              xData={statusData}
              xValueMember={""}
              xDispalyMember={""}
              xError={false}
              xErrorMessage={false}
              xDisable={false}
            />
          </Grid>
          <Grid item lg={2} md={4} xs={6} className="bintransfer-data-date">
            <CmpTextFieldEnter
              xref={LocationFocusOnLoad}
              xLabelText={"Doc.No"}
              xVariant={"outlined"}
              xValue={sinstanceData.docNo}
              xOnChange={(event) => fInstantPicking(event)}
              xReadOnly={false}
              xType={"text"}
              xName={"docNo"}
              xOnKeyUp={(e) => {
                if (e.key === "Enter") {
                  fLoad();
                }
              }}
              xOnEnter={(e) => {
                if (e.key === "Enter") {
                  fLoad();
                }
              }}
              xSmShow={!!vMediaQuery}
            />
          </Grid>
          <Grid
            item
            lg={2}
            md={4}
            xs={12}
            className="bintransfet-data-load-btn"
          >
            <CmpButton
              xbtnName="Load"
              xOnClick={fLoad}
              xVariant="contained"
              xSize="small"
            />
          </Grid>
        </Grid> */}
        <>
          {/* <Box
            sx={{ height: vMediaQuery ? "70vh" : "70vh", width: "100%" }}
            className="bin-transfer-data"
          >
            <DataGrid
              rowHeight={30}
              headerHeight={40}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0
                  ? "mui-even-row"
                  : "mui-odd-row"
              }
              sx={{
                border: 1,
                borderColor: "primary.light",
              }}
              getRowId={(row) => row.id}
              rows={itemRows}
              columns={sSummaryGridColumn2}
              // pageSize={10}
              // rowsPerPageOptions={[5]}
              hideFooter={itemRows.length < 100}
              experimentalFeatures={{ newEditingApi: false }}
              // onRowClick={(item) => navigate('/BinTrnasferForm/VocNo=' + item.row.DocTypCode, { state: item.row })}
              // onRowClick={(item) => navigate('/BinTrnasferForm', { state: item.row })}
              onRowClick={fInstantPickingHeadObj}
              components={{
                Toolbar: vMediaQuery ? "" : GridToolbar,
              }}
            />
          </Box> */}

          <InstantPickingSummaryCard
            data={itemRows}
            onClick={(items) => {
              fInstantPickingHeadObj(items);
            }}
          />
        </>

        <InstantPickingSummaryModal
          xOpen={showModal}
          fCloseModal={() => {
            setShowModal(false);
          }}
          xTitle="Filter"
          component={
            <>
              <Grid container spacing={2}>
                <Grid
                  item
                  // lg={2} md={4}
                  xs={6}
                >
                  <CmpSelectBox
                    xref={LocationFocusOnLoad}
                    xLabelText="Location"
                    xValue={
                      sinstanceData.loc === ""
                        ? vRdxuserLoc[0]?.UID
                        : sinstanceData.loc
                    }
                    xOnChange={(event) => fInstantPicking(event)}
                    xName={"loc"}
                    xData={sLocation}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={false}
                    xErrorMessage={false}
                    xDisable={false}
                  />
                </Grid>
                <Grid
                  item
                  //  lg={2} md={4}
                  xs={6}
                  className="bintransfer-data-date"
                >
                  <CmpDatePicker
                    xLabelText={"From"}
                    xValue={sinstanceData.dateFrom}
                    xOnChange={(newValue) => {
                      setInstanceData((obj) => ({
                        ...obj,
                        dateFrom: newValue.$d,
                      }));
                    }}
                    xName={"dateFrom"}
                    xError={false}
                    xErrorMessage={false}
                  />
                </Grid>
                <Grid
                  item
                  // lg={2} md={4}
                  xs={6}
                  className="bintransfer-data-date"
                >
                  <CmpDatePicker
                    xLabelText={"To"}
                    xValue={sinstanceData.dateTo}
                    xOnChange={(newValue) =>
                      setInstanceData((obj) => ({
                        ...obj,
                        dateTo: newValue.$d,
                      }))
                    }
                    xName={"dateTo"}
                    xError={false}
                    xErrorMessage={false}
                  />
                </Grid>
                <Grid
                  item
                  //  lg={2} md={4}
                  xs={6}
                >
                  <CmpSelectBox
                    xLabelText="Status"
                    xValue={
                      sinstanceData.statusVal == ""
                        ? statusData[0].id
                        : sinstanceData.statusVal
                    }
                    xOnChange={(event) => fInstantPicking(event)}
                    xName={"statusVal"}
                    xData={statusData}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={false}
                    xErrorMessage={false}
                    xDisable={false}
                  />
                </Grid>
                <Grid
                  item
                  // lg={2} md={4}
                  xs={12}
                  className="bintransfer-data-date"
                >
                  <CmpTextFieldEnter
                    xref={LocationFocusOnLoad}
                    xLabelText={"Doc.No"}
                    xVariant={"outlined"}
                    xValue={sinstanceData.docNo}
                    xOnChange={(event) => fInstantPicking(event)}
                    xReadOnly={false}
                    xType={"text"}
                    xName={"docNo"}
                    xOnKeyUp={(e) => {
                      if (e.key === "Enter") {
                        fLoad();
                      }
                    }}
                    xOnEnter={(e) => {
                      if (e.key === "Enter") {
                        fLoad();
                      }
                    }}
                    xSmShow={!!vMediaQuery}
                  />
                </Grid>
                <Grid
                  item
                  // lg={2}
                  // md={4}
                  xs={12}
                  className="bintransfet-data-load-btn text-center"
                >
                  <CmpButton
                    xbtnName="Load"
                    xOnClick={fLoad}
                    xVariant="contained"
                    xSize="small"
                  />
                </Grid>
              </Grid>
            </>
          }
        />
      </div>
    </div>
  );
}
